<template>
  <span v-on:mouseenter="mouseenter" v-on:mouseleave="mouseleave" ref="elementRef" style="line-height: 1em;">
    <slot></slot>
    <Teleport to="body">
      <div v-show="open" ref="containerRef" :class="'tooltip-container' + (helptoken?' with-button':'')">
        <pre v-if="text">{{ text }}</pre>
        <slot name='content'></slot>
        <button v-if="helptoken" @click="openHelp" class="help-button">?</button>
      </div>
    </Teleport>
  </span>
</template>
  
<script>
import Vue from 'vue';
import Teleport from 'vue2-teleport';
  
export default {
  props:{
      text: { type: String, default:""},
      helptoken: { type: String },
      showDelay: {type: Number, default: 1000},
      hideDelay: {type: Number, default: 300},
  },
  components: {
    Teleport,
  },
  data() {
    return { 
      open: false,
      showTimer: null,
      hideTimer: null,
      mlText:""
    }
  },
  methods:{
    openHelp(){
      this.open = false;
      this.helptoken && this.$utils.openHelp?.( this.helptoken );
    },
    show(){
      this.open = true;
      Vue.nextTick().then(() => {
        let rect = this.$refs.elementRef?.getBoundingClientRect()
        let cnt = this.$refs.containerRef
        if (cnt && rect) {
          let screenRect = document.body.getBoundingClientRect();
          let popupRect = cnt.getBoundingClientRect()
          let top = rect.bottom + 2;
          cnt.style.top = rect.bottom + 2 + 'px'
          const left = (rect.left + rect.right) / 2 - popupRect.width / 2;

          if (left + popupRect.width + 10 > screenRect.width) cnt.style.left = screenRect.width - popupRect.width - 10 + 'px';
          else if (left < 10) cnt.style.left = '10px';
          else cnt.style.left = left + 'px'

          if (top + popupRect.height + 2 > screenRect.height) cnt.style.top = rect.top - popupRect.height - 2 + 'px';
          else cnt.style.top = top + 'px'

          cnt?.addEventListener('mouseenter', () => {
            clearTimeout(this.hideTimer)
          })
          cnt?.addEventListener('mouseleave', () => {
            this.hideTimer = setTimeout(() => {
              this.hideTimer = undefined
              this.open = false
            }, this.hideDelay)
          })
        }
      })
    },
    mouseenter(){
      if (!this.text && !this.$slots.content) return;
      this.showTimer = setTimeout(() => {
        this.showTimer = undefined
        this.show();
      }, this.showDelay)
    },
    mouseleave(){
      if (this.showTimer) {
        clearTimeout(this.showTimer)
        this.showTimer = undefined
      } else {
        this.hideTimer = setTimeout(() => {
          this.hideTimer = undefined
          this.open = false;
        }, this.hideDelay)
      }
    }
  },
  mounted(){

  }
}
</script>

<style scoped>
.tooltip-container {
  position: fixed;
  display: flex;
  gap: 2px;
  flex-wrap: nowrap;
  align-items: center;
  z-index: 999;
  background-color: rgba(70, 70, 70, 0.8);
  color: #eee;
  border-radius: 10px;
  border: 1px solid rgb(0 0 0 / 32%);
  padding: 4px 8px;

  box-shadow: -1px 3px 4px 0px rgba(0, 0, 0, 0.5);
  -webkit-box-shadow: -1px 3px 4px 0px rgba(0, 0, 0, 0.5);
  -moz-box-shadow: -1px 3px 4px 0px rgba(0, 0, 0, 0.5);
}
.tooltip-container.with-button{
  padding: 4px 4px 4px 12px;
  pre{
    margin-right: 8px;
  }
}

.tooltip-container >>> pre{
  font-family: 'OwnersText', Roboto, sans-serif;
}

.help-button {
  display: flex;
  border-radius: 50%;
  width: 25px;
  height: 25px;
  border: 1px solid #eee;
  background-color: transparent;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  padding: 1px 1px 0 1px;
  align-items: center;
  justify-content: center;
}

button.help-button:hover{
  background-color: #555;
}
</style>
